import { flashBagSuccess } from '@tools/flashbag';
import { createCenteredPopupWindow } from '@tools/window-center';
import { translations } from '@tools/translations/translations';

const hideDropdown = (listElement, btn) => {
  // eslint-disable-next-line no-param-reassign
  listElement.style.display = 'none';
  listElement.classList.remove('active');
  btn.classList.remove('active');
};

export const extendableButton = (btn, listElement) => {
  if (!btn) {
    return;
  }

  btn.addEventListener('click', (event) => {
    event.stopPropagation();
    if (btn.classList.contains('active')) {
      hideDropdown(listElement, btn);
      return;
    }

    // eslint-disable-next-line no-param-reassign
    listElement.style.display = 'block';
    listElement.classList.add('active');
    btn.classList.add('active');
  });

  window.addEventListener('click', () => {
    if (btn.classList.contains('active')) {
      hideDropdown(listElement, btn);
    }
  });
};

function copyInputValue(el) {
  navigator.clipboard.writeText(el.value).then(() => {
    flashBagSuccess(translations.messages['offer.link.copied']);
  });
}

export const extendableOfferButton = (shareButtonContainer) => {
  shareButtonContainer.querySelectorAll('li > input[aria-hidden]').forEach((el) => {
    el.parentElement.addEventListener('click', () => copyInputValue(el));
  });

  shareButtonContainer.querySelectorAll('.social-network-link').forEach((el) => {
    el.addEventListener('click', () => createCenteredPopupWindow(el.dataset.href, '', 950, 500));
  });

  extendableButton(shareButtonContainer.querySelector('a'), shareButtonContainer.querySelector('ul'));
};
